import Cookies from "js-cookie";
module.exports = {
  cookieToJson: function(param) {
    if (Cookies.get(param)) {
      return JSON.parse(Cookies.get(param));
    }
  },
  setMediaLen: function(ctn) {
    if (ctn != "" && ctn != undefined) {
      var num = parseInt(ctn);
      if (num >= 60) {
        var whole = Math.floor(num / 60);
        var residue = num % 60;
        if (residue == 0) {
          return whole + "'";
        } else {
          return whole + "'" + residue + '"';
        }
      } else {
        return num + '"';
      }
    } else {
      return "0'";
    }
  },

  // const url = 'http://www.abc.com/test.php?id=1&from=index';
  // var res = getUrlParams();
  // var res1 = getUrlParams('id');
  // console.log(res); //  [{id: "1"}, {from: "index"}]
  // console.log(res1); // 1
  getUrlParams: function(name) {
    // 不传name返回所有值，否则返回对应值
    var url = window.location.search;
    if (url.indexOf("?") == 1) {
      return false;
    }
    url = url.substr(1);
    url = url.split("&");
    var name = name || "";
    var nameres;
    // 获取全部参数及其值
    for (var i = 0; i < url.length; i++) {
      var info = url[i].split("=");
      var obj = {};
      obj[info[0]] = decodeURI(info[1]);
      url[i] = obj;
    }
    // 如果传入一个参数名称，就匹配其值
    if (name) {
      for (var i = 0; i < url.length; i++) {
        for (const key in url[i]) {
          if (key == name) {
            nameres = url[i][key];
          }
        }
      }
    } else {
      nameres = url;
    }
    // 返回结果
    return nameres;
  },

  //添加url参数
  addUrlParams: function(url, paramKey, paramVal) {
    var andStr = "?";
    var beforeparam = url.indexOf("?");
    if (beforeparam != -1) {
      andStr = "&";
    }
    return url + andStr + paramKey + "=" + encodeURIComponent(paramVal);
  },
  /**
   * 判断指定名称的复选框是否被选中
   *
   * @param {}
   *            chname复选框名称
   */
  chkCheckCha: function(chname) {
    var obj = jQuery("[name='" + chname + "']");
    var isCheck = false;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].checked == true) {
        isCheck = true;
        break;
      }
    }
    return isCheck;
  },

  // 合并时间段
  newArr: function(arr) {
    for (var i = 0; i < arr.length; i++) {
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i].substr(-5) === arr[j].substr(0, 5)) {
          let frontStr = arr[i].substr(0, 5),
            endStr = arr[j].substr(-5);
          arr.splice(i, 1, frontStr + "-" + endStr);
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  },
  commonFunc: function(str) {
    $(".publicPop-content-con").html(str);
    let aggrementLayer = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["600px", ""],
      title: "",
      id: "publicPopCon",
      closeBtn: 0,
      content: $("#publicPop"),
      end: function() {
        $("#publicPop").hide();
      }
    });
    $("#publicPop .icon-close").click(function() {
      layer.close(aggrementLayer);
    });
  },
  urlPopCon(url) {
    $(".publicPop-content-con").html(
      "<iframe src=" +
        url +
        ' width="100%" height="600px" scrolling="yes"></iframe>'
    );
    let privacyLayer = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["600px", ""],
      title: "",
      id: "publicPopCon",
      closeBtn: 0,
      content: $("#publicPop"),
      end: function() {
        $("#publicPop").hide();
      }
    });
    $("#publicPop .icon-close").click(function() {
      layer.close(privacyLayer);
    });
  },
  loadDefaultHead: function() {
    $("img.headPortrait").on("error", function() {
      if ($(this).attr("data-Sex")) {
        $(this).attr(
          "src",
          "http://192.168.200.81:58103/UploadFile/SystemFile/app_Defaultboy.jpg"
        );
      } else {
        $(this).attr(
          "src",
          "http://192.168.200.81:58103/UploadFile/SystemFile/app_Defaultgirl.jpg"
        );
      }
    });
  },
  /**
   * 日期对象转换为指定格式的字符串
   * @param f 日期格式,格式定义如下 yyyy-MM-dd HH:mm:ss
   * @param date Date日期对象, 如果缺省，则为当前时间
   *
   * YYYY/yyyy/YY/yy 表示年份
   * MM/M 月份
   * W/w 星期
   * dd/DD/d/D 日期
   * hh/HH/h/H 时间
   * mm/m 分钟
   * ss/SS/s/S 秒
   * @return string 指定格式的时间字符串
   */
  dateToStr(formatStr, date) {
    formatStr = arguments[0] || "yyyy-MM-dd HH:mm:ss";
    date = arguments[1] || new Date();
    var str = formatStr;
    var Week = ["日", "一", "二", "三", "四", "五", "六"];
    str = str.replace(/yyyy|YYYY/, date.getFullYear());
    str = str.replace(
      /yy|YY/,
      date.getYear() % 100 > 9
        ? (date.getYear() % 100).toString()
        : "0" + (date.getYear() % 100)
    );
    str = str.replace(
      /MM/,
      date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
    );
    str = str.replace(/M/g, date.getMonth());
    str = str.replace(/w|W/g, Week[date.getDay()]);

    str = str.replace(
      /dd|DD/,
      date.getDate() > 9 ? date.getDate().toString() : "0" + date.getDate()
    );
    str = str.replace(/d|D/g, date.getDate());

    str = str.replace(
      /hh|HH/,
      date.getHours() > 9 ? date.getHours().toString() : "0" + date.getHours()
    );
    str = str.replace(/h|H/g, date.getHours());
    str = str.replace(
      /mm/,
      date.getMinutes() > 9
        ? date.getMinutes().toString()
        : "0" + date.getMinutes()
    );
    str = str.replace(/m/g, date.getMinutes());

    str = str.replace(
      /ss|SS/,
      date.getSeconds() > 9
        ? date.getSeconds().toString()
        : "0" + date.getSeconds()
    );
    str = str.replace(/s|S/g, date.getSeconds());

    return str;
  }
};
